import React, { useContext, useEffect, useState } from 'react';
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import Loader from '../../../Components/Loader/Loader';
import Card from '../../../Components/Card/Card';
import { Button } from 'primereact/button';
import { AuthContext } from '../../../Context/AuthContext/AuthContext';
import { Checkbox } from 'primereact/checkbox';
import { getAllSolicitudesEdicion, UpdSolicitudesEdicion } from '../../../../Base/API/Proveedores/ProveedoresRequest';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { encryptor } from "../../../Services/Crypto/Crypto";
import { getDateTimeStringSQL24 } from '../../../Services/Moment/Luxon';
import { Tag } from 'primereact/tag';
import CalendarioMensual from "../../../Components/CalendarioMensual/CalendarioMensual";
import ReporteSolicitudEdicionProveedor from './ReporteSolicitudEdicionProveedores';
import { InputText } from 'primereact/inputtext';

const SolicitudesEdicionProveedoresScreen = () => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const { userAuth } = useContext(AuthContext);
  const [showDialogPassword, setShowDialogPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [solicitudSeleccionada, setSolicitudSeleccionada] = useState(null);
  const [validandoPassword, setValidandoPassword] = useState(false);
  const [dialogReporte, setDialogReporte] = useState(false);
  const [dates, setDates] = useState([new Date(), new Date()]);
  const [reporteData, setReporteData] = useState({ IdSolicitudEdicion: null });
  const [user, setUser] = useState('')

  const obtenerInformacion = async (fechaInicio, fechaFinal) => {
    setLoading(true);

    const result = await getAllSolicitudesEdicion(
      `${dates[0]} 00:00:00`,
      `${dates[1]} 23:59:59`
    );

    setData(result ?? []);
    setLoading(false);
  };

  const abrirReporte = (rowData) => {
    setReporteData({ IdSolicitudEdicion: rowData.IdSolicitudEdicion });
    setDialogReporte(true);
  };

  const hideReporte = () => {
    setDialogReporte(false);
    setReporteData({ IdSolicitudEdicion: null });
  };

  const aprobarSolicitud = async () => {
    setValidandoPassword(true);
    try {
      const user = {
        Password: await encryptor(password),
        idUser: await encryptor(userAuth.idUser + '')
      };

      const result = await UpdSolicitudesEdicion({
        user,
        Datos: [{
          IdSolicitudEdicion: solicitudSeleccionada.IdSolicitudEdicion,
          IdEstado: 3118,
          DateEdit: getDateTimeStringSQL24(new Date()),
          Reactivar: solicitudSeleccionada.Reactivar,
          IdUserAutorizo: userAuth.idUser
        }]
      });
      console.log({result});
      if (result?.success) {

        toast.current.show({ severity: 'success', summary: 'Correcto', detail: 'Solicitud aprobada correctamente.', life: 3000 });
        obtenerInformacion();
        hideDialogPassword();
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Contraseña incorrecta.', life: 3000 });
      }
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se pudo aprobar la solicitud.', life: 3000 });
    } finally {
      setValidandoPassword(false);
    }
  };

  const hideDialogPassword = () => {
    setShowDialogPassword(false);
    setSolicitudSeleccionada(null);
    setPassword('');
  };

  const EstadoTemplate = (rowData) => {
    switch (rowData.IdEstado) {
      case 3117:
        return <Tag style={{ width: 100, backgroundColor: "#749bff" }} value={rowData.NombreEstado} />
      case 3118:
        return <Tag style={{ width: 100, backgroundColor: "#62d17e" }} value={rowData.NombreEstado} />
      case 3119:
        return <Tag style={{ width: 100, backgroundColor: "#a3a7a8" }} value={rowData.NombreEstado} />
      default:
        return <span>{rowData.NombreEstado}</span>
    }
  }

  const CheckTemplate = (value) => (
    <Checkbox checked={!!value} style={{ marginBottom: 5 }} disabled />
  );

  const table = {
    Data: data,
    Columns: [
      {
        field: 'IdSolicitudEdicion',
        header: 'Id',
        className: 'Xsmall',
        hidden: userAuth.IdRol === 1,
      },
      {
        field: 'IdProveedor',
        header: 'Id Proveedor',
        className: 'Xsmall',
        hidden: userAuth.IdRol === 1,
      },
      {
        field: 'Correlativo',
        header: 'Correlativo',
        className: 'small',
        filter: true,
        alignFrozen: 'left',
      },
      {
        field: 'NombreProveedor',
        header: 'Proveedor',
        className: 'Xlarge',
        filter: true,
        alignFrozen: 'left',
      },
      {
        field: 'NombreEstado',
        header: 'Estado',
        className: 'small',
        Format: 'Template',
        body: (rowData) => EstadoTemplate(rowData),
        filter: true,
      },
      {
        field: 'Comentario',
        header: 'Comentario',
        className: 'large',
      },
      {
        field: 'NombreUsuario',
        header: 'Solicitó',
        className: 'small',
        filter: true,
      },
      {
        field: 'Autorizo',
        header: 'Autorizó',
        className: 'small',
        filter: true,
      },
      {
        field: 'Fecha',
        header: 'Fecha',
        className: 'medium',
        Format: 'Datetime',
      },
      {
        field: 'InformacionEmpresa',
        header: 'Empresa',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.InformacionEmpresa),
        alignFrozen: 'right',
      },
      {
        field: 'InformacionContacto',
        header: 'Contacto',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.InformacionContacto),
        alignFrozen: 'right',
      },
      {
        field: 'InformacionBancaria',
        header: 'Bancaria',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.InformacionBancaria),
        alignFrozen: 'right',
      },
      {
        field: 'InformacionComercial',
        header: 'Comercial',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.InformacionComercial),
        alignFrozen: 'right',
      },
      {
        field: 'InformacionFinanciera',
        header: 'Financiera',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.InformacionFinanciera),
        alignFrozen: 'right',
      },
      {
        field: 'Documentacion',
        header: 'Documentación',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.Documentacion),
        alignFrozen: 'right',
      },
      {
        field: 'Reactivar',
        header: 'Reactivar',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.Reactivar),
        alignFrozen: 'right',
      },
      {
        field: 'HabilitarPago',
        header: 'Habilitar Pago',
        className: 'Xsmall',
        Format: 'Template',
        body: (rowData) => CheckTemplate(rowData.HabilitarPago),
        alignFrozen: 'right',
      },
      {
        field: 'IdSolicitudEdicion',
        header: 'Acciones',
        Format: 'Botones',
        frozen: "frozen",
        alignFrozen: "right",
        Botones: [
          {
            icon: 'ri-checkbox-circle-line',
            tooltip: 'Aprobar',
            onClick: (data) => {
              if (data.IdEstado !== 3117) {
                toast.current.show({
                  severity: 'warn',
                  summary: 'Acción No Permitida',
                  detail: `Esta solicitud ya se encuentra en estado: ${data.NombreEstado}`,
                  life: 3000
                });
                return;
              }

              setSolicitudSeleccionada(data);
              setShowDialogPassword(true);
            },
            disabled: (data) => data?.IdEstado !== 3117
          },
          {
            icon: 'ri-printer-line',
            onClick: (data) => abrirReporte(data),
            disabled: (data) => data?.IdEstado !== 3118 && data?.IdEstado !== 3119
          }
        ]
      }
    ],
  };

  useEffect(() => {
    obtenerInformacion();
  }, []);

  return (
    <div style={{ width: '99%', height: '90vh' }}>
      <Toast ref={toast} />
      <Loader loading={loading} querySelector='#SolicitudesEdicion' />
      <Card
        titulo={
          <div className="d-flex gap" style={{ alignItems: "center" }}>
            <CalendarioMensual
              getInfo={async (fechaFormato) => {
                const result = await getAllSolicitudesEdicion(
                  fechaFormato[0],
                  `${fechaFormato[1].split(" ")[0]} 23:59:59`
                );
                return result ?? [];
              }}
              data={data}
              setData={setData}
              dates={dates}
              setDates={setDates}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        }
        contenido={
          <div className='pt-4' style={{ height: '85vh' }} id='SolicitudesEdicion'>
            <AgGrid table={table} />
          </div>
        }
      />
      <Dialog
        visible={showDialogPassword}
        onHide={hideDialogPassword}
        header="Confirmar contraseña"
        style={{ width: '500px' }}
      >
        <div className='d-flex flex-row'>
          <span className="p-inputgroup-addon">
            <i className="pi pi-lock"></i>
          </span>
          <div style={{ height: 0 , overflow: 'hidden', width: 0 }}>
            <InputText value={user} onChange={(e) => setUser(e.target.value)} id="user" />
          </div>

          <Password
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && aprobarSolicitud()}
            toggleMask
            feedback={false}
          />
        </div>

        <div className="d-flex justify-content-end">
          <Button
            label="Cancelar"
            className="p-button-secondary"
            onClick={hideDialogPassword}
          />

          <Button
            label="Habilitar"
            onClick={aprobarSolicitud}
            disabled={!password}
            loading={validandoPassword}
          />
        </div>
      </Dialog>
      <ReporteSolicitudEdicionProveedor
        dialog={dialogReporte}
        hideDialog={hideReporte}
        IdSolicitudEdicion={reporteData.IdSolicitudEdicion}
      />
    </div>
  );
};

export default SolicitudesEdicionProveedoresScreen;